// Where the Event Analytics PDF (PDFExportButton.web.js) cuts the report into
// pages: never through a row, card or chart, and never between a title and
// what it heads.

// US Letter, in mm: the EventLive logo at the top right, the report below it.
export const PDF_PAGE = { width: 215.9, height: 279.4, margin: 12.7, logoTop: 9, logoHeight: 5, contentTop: 19 };
// The report's width while it's printed: at 96 dpi it fills the page between the margins.
export const PRINT_WIDTH = Math.round((PDF_PAGE.width - 2 * PDF_PAGE.margin) * (96 / 25.4));

// rects: [{ top, bottom, next }] in px from the report's top (the elements
// marked data-pdf). `next` (a title) keeps the block on the page of the block
// after it.
export const keepBlocks = (rects = []) => {
  const sorted = rects
    .filter((r) => r && r.bottom > r.top)
    .sort((a, b) => a.top - b.top || a.bottom - b.bottom);
  return sorted.map((r, i) => {
    if (!r.next) return { top: r.top, bottom: r.bottom };
    const following = sorted.slice(i + 1).find((s) => s.top >= r.bottom - 1);
    return { top: r.top, bottom: Math.max(r.bottom, following ? following.bottom : r.bottom) };
  });
};

// The pages, as [start, end] px of a report `height` tall, each at most
// `pageHeight`: a page ends just above the first block that doesn't fit whole.
// A block taller than a page is cut where the page ends. A last sliver (the
// report's bottom padding) joins the page before instead of starting one.
export const pageSlices = (height, pageHeight, blocks = []) => {
  const slices = [];
  let start = 0;
  while (height - start > 1) {
    let end = Math.min(height, start + pageHeight);
    if (end < height) {
      for (let moved = true; moved; ) {
        moved = false;
        for (const b of blocks) {
          if (b.top > start + 1 && b.top < end && b.bottom > end + 1) {
            end = b.top;
            moved = true;
          }
        }
      }
    }
    if (end <= start + 1) end = Math.min(height, start + pageHeight);
    slices.push([start, end]);
    start = end;
  }
  const last = slices[slices.length - 1];
  if (slices.length > 1 && last[1] - last[0] < 8) {
    slices.pop();
    slices[slices.length - 1][1] = height;
  }
  return slices;
};
